import i18n from '@/services/i18n';

// #region Currency
export function formatToCurrency(value, languageCode?: string) {
    if (!value) return;

    const number = parseFloat(currencyRawValue(value));
    return new Intl.NumberFormat(languageCode ?? i18n.language).format(number);
}
export function currencyRawValue(value) {
    if (!value) return;
    return value.replace(/[^\d]/g, '');
}

export const formatCurrency = (input: any): null | undefined | string | number => {
    return formatNumber(input);
};
// #endregion Currency

// #region Number
export const formatNumber = (input: any): null | undefined | string | number => {
    if (input === null || input === undefined) {
        return null;
    }

    if (isNaN(input)) {
        return null;
    }
    const [integerPart, decimalPart] = input?.toString()?.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};
export const formatLargeNumber = (input: any): string => {
    const num = parseInt(input);

    if (isNaN(num)) return '0';

    const BILLION = 1_000_000_000;
    const MILLION = 1_000_000;
    const THOUSAND = 1_000;

    if (num >= BILLION) {
        return (num / BILLION)?.toFixed(1)?.replace(/\.0$/, '') + 'B';
    }
    if (num >= MILLION) {
        return (num / MILLION)?.toFixed(1)?.replace(/\.0$/, '') + 'M';
    }
    if (num >= THOUSAND) {
        return (num / THOUSAND)?.toFixed(1)?.replace(/\.0$/, '') + 'K';
    }

    return num?.toString();
};
// #endregion Number

// #region  Full width -> half width
export const convertFullToHalf = (value: string): string => {
    return value.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
};
// #endregion
